import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
//redux
import { silentLogin } from "store/bailiff/login/login.action";
import { setLoadingSuccess, setLoginFail } from "store/user/login/login.action";
import { isLoggedSelector as isLoggedSelectorBase } from "store/bailiff/auth/bailiff_auth.selector";
import { isLoggedSelector as isLoggedSelectorUser } from "store/user/auth/user_auth.selector";
import { message } from "antd";

//
//component
//redux
//selector
//actions
const TriggerLogIn = () => {
  // -------------------------- VAR ----------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const Alogged = useSelector(isLoggedSelectorUser);
  const Blogged = useSelector(isLoggedSelectorBase);
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    const time = `time ${moment()?.toISOString()}`;
    if (Alogged === true && Blogged === false) {
      dispatch(
        silentLogin((res) => {
          if (res?.status === 500) {
            message.error(res?.data);
            dispatch(setLoginFail(res?.data));
          }
          if (res?.status === 200) {
            dispatch(setLoadingSuccess());
          }
        })
      );
      console.log("trigger login" + time);
    }
  }, [Alogged, Blogged, dispatch]);

  // -------------------------- RETURN --------------------------

  return <></>;
};
export default TriggerLogIn;
